/**
 * This is a placeholder file for the wizard configuration.
 *
 * If you're migrating an older template to use the configuration wizard, you may import this file to the main config:
 *
 * ```
 * import { getWizardConfig } from "./wizard"
 *
 * init({
 *     // Everything else
 *     ...getWizardConfig(),
 *     // Overrides for the wizard config
 * })
 * ```
 *
 * This file will be generated through the config wizard. Do not edit directly.
 */
export function getWizardConfig() {
    return {}
}
